import {
    ButtonGroup,
    Checkbox,
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify';
import Label from 'src/components/label';
import ConfirmLockModal from 'src/components/modal/ConfirmLockModal';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import CreateScreenModal from 'src/components/modal/CreateScreenModal';
import { DecentralizationListHead } from 'src/sections/@dashboard/decentralization';
import { sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';

const TablePermissionControlScreen = ({ tableData, fuctGet, valueUser, fuctGetDataScreenGroup, searchValue }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const [dataAction, setDataAction] = useState({});
    const isEdit = useRef(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [visibleDelete, setVisibleDelete] = useState(false);
    const delFlags = useRef(false);
    const [deleleFlags, setDeleleFlags] = useState(false);

    const addFlagsPermission = useRef(false);
    const [permissionFlags, setPermissionFlags] = useState(false);

    const [visibleLock, setVisibleLock] = useState(false);
    const lock = useRef(false);
    const [lockFlags, setLockFlags] = useState(false);

    const screenPermissions = useRef({});
    const user = useRef({});

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
        const menu = sessionStorage.getItem('menu');
        if (menu) {
            try {
                const data = JSON.parse(crypt.deCode(menu));
                // console.log('Loading menu', data[0]);
                screenPermissions.current = data[0].filter((item) => item.screens_key === 'phan_quyen_nguoi_dung')[0];
                // console.log('screenPermissions', screenPermissions);
            } catch (error) {}
        }
    }, []);

    const tableDataHeader = [
        { id: 1, label: t('screen'), alignRight: false },
        { id: 2, label: t('screens_key'), alignRight: false },
        { id: 3, label: t('view'), alignRight: false },
        { id: 4, label: t('insert'), alignRight: false },
        { id: 5, label: t('update'), alignRight: false },
        { id: 6, label: t('delete'), alignRight: false },
        { id: 7, label: t('lock'), alignRight: false },
        { id: 8, label: t('import'), alignRight: false },
        { id: 9, label: t('export'), alignRight: false },
        { id: 10, label: t('status'), alignRight: false },
        { id: 'Thao tác', label: '', alignRight: false },
    ];

    const handleDelete = () => {
        if (!dataAction.screen_id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [dataAction.screen_id];
        sendRequest(serviceList.deleteScreen, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDelete(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleDelete(false);
            fuctGet && fuctGet(valueUser);
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const handleChange = (event, item, key) => {
        const data = {
            ...item,
            // permiss_screen: {
            //     ...item.permiss_screen,
            //     [key]: item.permiss_screen[key] === '2' ? '0' : '2'
            // }
            [key]: item[key] === '2' ? '1' : '2',
        };
        // console.log("handeChang", data);
        if (key === 'import') {
            key = 'import_';
        }
        handlePermission(key, data);
    };

    const handlePermission = (key, data) => {
        if (addFlagsPermission.current === true) return;

        addFlagsPermission.current = true;
        setPermissionFlags(true);
        const InVal = [
            valueUser,
            data.screen_id,
            key,
            data.search,
            data.insert,
            data.update,
            data.delete,
            data.block,
            data.import,
            data.export,
        ];
        sendRequest(serviceList.processScreenGroup, InVal, permissionResult, true, timeOutFunctPermission, 40000);
    };

    const permissionResult = (reqInfoMap, message) => {
        setPermissionFlags(false);
        addFlagsPermission.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            fuctGet && fuctGetDataScreenGroup(valueUser);
        }
    };

    const timeOutFunctPermission = (reqInfo) => {
        setPermissionFlags(false);
        addFlagsPermission.current = false;
        toast.error(t('error.time_out'));
    };

    const handleLock = () => {
        if (!dataAction.screen_group_id) return toast.error(t('error.system_error'));
        if (lock.current) {
            return;
        }
        setLockFlags(true);
        lock.current = true;
        const InVal = [dataAction.screen_group_id, dataAction.work_status === '1' ? '0' : '1', valueUser];
        sendRequest(serviceList.updateActiveScreenGroup, InVal, deviceLockResult, true, timeOutFunctDeviceLock, 40000);
    };

    const deviceLockResult = (reqInfoMap, message) => {
        setLockFlags(false);
        lock.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleLock(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleLock(false);
            fuctGet && fuctGetDataScreenGroup(valueUser);
        }
    };

    const timeOutFunctDeviceLock = (reqInfo) => {
        setLockFlags(false);
        lock.current = false;
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <CreateScreenModal
                visible={visibleEdit}
                setVisible={setVisibleEdit}
                dataUpdate={dataAction}
                isEdit
                fuctGet={fuctGet}
                valueUser={valueUser}
            />
            <ConfirmModal visible={visibleDelete} setVisible={setVisibleDelete} handleDelete={handleDelete} />
            <ConfirmLockModal visible={visibleLock} setVisible={setVisibleLock} handleSave={handleLock} />
            {/* <TableListToolbar getValue={searchValue} /> */}
            <TableContainer sx={{ paddingTop: 0, maxHeight: 450, overflow: 'auto' }}>
                <Table stickyHeader>
                    <DecentralizationListHead headLabel={tableDataHeader} rowCount={tableData.length} />
                    <TableBody>
                        {tableData.length > 0 ? (
                            tableData.map((item) => {
                                return (
                                    <TableRow hover key={item.id} tabIndex={-1} role="checkbox">
                                        <TableCell padding="checkbox"></TableCell>

                                        <TableCell component="th" scope="row" padding="5px">
                                            <Stack direction="row" alignItems="center" spacing={2}>
                                                <Typography variant="subtitle2" noWrap>
                                                    {t(item.screens_key).toUpperCase()}
                                                </Typography>
                                            </Stack>
                                        </TableCell>
                                        <TableCell align="left" style={{ maxWidth: '100%', minWidth: '50px' }}>
                                            <Typography variant="subtitle3" noWrap>
                                                {item.screens_key}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item.search === '1' ? true : false}
                                                disabled={
                                                    item.work_status === '0' ||
                                                    !valueUser ||
                                                    user.current?.group_user !== '1'
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e) => handleChange(e, item, 'search')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item.insert === '1' ? true : false}
                                                disabled={
                                                    item.work_status === '0' ||
                                                    !valueUser ||
                                                    user.current?.group_user !== '1'
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e) => handleChange(e, item, 'insert')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item.update === '1' ? true : false}
                                                disabled={
                                                    item.work_status === '0' ||
                                                    !valueUser ||
                                                    user.current?.group_user !== '1'
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e) => handleChange(e, item, 'update')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item.delete === '1' ? true : false}
                                                disabled={
                                                    item.work_status === '0' ||
                                                    !valueUser ||
                                                    user.current?.group_user !== '1'
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e) => handleChange(e, item, 'delete')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item.block === '1' ? true : false}
                                                disabled={
                                                    item.work_status === '0' ||
                                                    !valueUser ||
                                                    user.current?.group_user !== '1'
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e) => handleChange(e, item, 'block')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item.import === '1' ? true : false}
                                                disabled={
                                                    item.work_status === '0' ||
                                                    !valueUser ||
                                                    user.current?.group_user !== '1'
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e) => handleChange(e, item, 'import')}
                                            />
                                        </TableCell>

                                        <TableCell align="left">
                                            <Checkbox
                                                label="Parent"
                                                checked={item.export === '1' ? true : false}
                                                disabled={
                                                    item.work_status === '0' ||
                                                    !valueUser ||
                                                    user.current?.group_user !== '1'
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e) => handleChange(e, item, 'export')}
                                            />
                                        </TableCell>
                                        <TableCell align="left">
                                            <Label color={(item.work_status === '0' && 'error') || 'primary'}>
                                                {item.work_status === '1' ? t('active') : t('band')}
                                            </Label>
                                        </TableCell>
                                        <TableCell align="right" style={{ maxWidth: '150px' }}>
                                            <ButtonGroup
                                                variant="text"
                                                aria-label="text button group"
                                                style={{ display: 'flex', justifyContent: 'flex-start' }}
                                            >
                                                {user.current?.group_user === '1' && (
                                                    <IconButton
                                                        size="large"
                                                        color={(item.work_status === '0' && 'error') || 'primary'}
                                                        onClick={() => {
                                                            setDataAction(item);
                                                            setVisibleLock(true);
                                                        }}
                                                    >
                                                        <Iconify
                                                            icon={
                                                                item.work_status !== '1'
                                                                    ? 'material-symbols:lock'
                                                                    : 'material-symbols:lock-open'
                                                            }
                                                        />
                                                    </IconButton>
                                                )}
                                                {user.current?.group_user === '1' && (
                                                    <IconButton
                                                        size="large"
                                                        color={'warning'}
                                                        onClick={() => {
                                                            setDataAction(item);
                                                            isEdit.current = true;
                                                            setVisibleEdit(true);
                                                        }}
                                                    >
                                                        <Iconify icon={'eva:edit-fill'} />
                                                    </IconButton>
                                                )}
                                                {user.current?.group_user === '1' && (
                                                    <IconButton
                                                        size="large"
                                                        color={'error'}
                                                        onClick={() => {
                                                            setDataAction(item);
                                                            setVisibleDelete(true);
                                                        }}
                                                    >
                                                        <Iconify icon={'eva:trash-2-outline'} />
                                                    </IconButton>
                                                )}
                                            </ButtonGroup>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        ) : (
                            <></>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default TablePermissionControlScreen;
